import React from 'react';
import { Link } from 'dva/router';
import { Result,Button } from 'antd';

export default () => (
  <Result
    status="500"
    title="500"
    subTitle="抱歉，服务器报告了一个错误。"
    extra={
      <Button type="primary">
        返回首页
      </Button>
    }
  ></Result>
);
